import React, { useEffect, useState } from 'react';
import { animated, useSpring } from '@react-spring/web';
import { ExpandGroup } from '@pushpay/expand';
import { clsx } from '@pushpay/styles';
import { useConstant } from '@pushpay/utils';
import { sidebarCollapsedWidthPx, sidebarExpandedWidthPx } from '../sidebar';
import { NavigationItemGroup } from './navigation-item-group';
import { NavigationLinkItem } from './navigation-link-item';
import { useNavigationStyles } from './navigation-styles';
import { useNavigation } from './use-navigation';

function useNavigationScrolling(navRef) {
  const [scrolling, setScrolling] = useState(false);
  useEffect(() => {
    let timeout;

    function handleScrolling() {
      window.clearTimeout(timeout);
      setScrolling(true);
      timeout = window.setTimeout(() => setScrolling(false), 50);
    }

    const navElement = navRef.current;
    navElement.addEventListener('scroll', handleScrolling);
    return () => navElement.removeEventListener('scroll', handleScrolling);
  }, [navRef]);
  return scrolling;
}

let navigationCounter = 0;
export function Navigation({
  items,
  classes: classesProp,
  className: classNameProp
}) {
  const classes = useNavigationStyles(classesProp);
  const className = clsx(classes.root, classNameProp);
  const {
    displayStyle,
    navRef,
    onNavKeyDown,
    navContainerRef
  } = useNavigation();
  const {
    width
  } = useSpring({
    width: displayStyle === 'collapsed' ? sidebarCollapsedWidthPx : sidebarExpandedWidthPx
  });
  const navigationScrolling = useNavigationScrolling(navContainerRef);
  const navigationId = useConstant(() => `sidebar-${navigationCounter++}`);
  return /*#__PURE__*/React.createElement("nav", {
    ref: navRef,
    className: className,
    "aria-label": `navigation-${navigationId}`
  }, /*#__PURE__*/React.createElement("div", {
    role: "none",
    onKeyDown: onNavKeyDown()
  }, /*#__PURE__*/React.createElement(ExpandGroup, null, /*#__PURE__*/React.createElement(animated.ul, {
    className: classes.list,
    style: {
      width
    }
  }, items.map(item => /*#__PURE__*/React.createElement("li", {
    key: item.label,
    className: classes.listItem
  }, item.children ? /*#__PURE__*/React.createElement(NavigationItemGroup, Object.assign({}, item, {
    classes: classes,
    navigationId: navigationId,
    displayStyle: displayStyle,
    scrolling: navigationScrolling
  })) : /*#__PURE__*/React.createElement(NavigationLinkItem, Object.assign({}, item, {
    classes: classes,
    displayStyle: displayStyle,
    scrolling: navigationScrolling
  }))))))));
}